import { TLang } from '../entities/ui.entities';
import en from '../lang/en.json';
import fr from '../lang/fr.json';
import es from '../lang/es.json';
import { ReactElement } from 'react';

export const translate = (
  lang: TLang | undefined,
  content: string,
  ...values: Array<any>
) => {
  if (typeof content !== 'string') {
    try {
      content = (content as any).toString();
    } catch (error) {
      content = 'Unknown error';
    }
  }
  let idx = 0;
  const data: any =
    lang === 'en' ? en : lang === 'fr' ? fr : lang === 'es' ? es : en;
  const template = content in data ? data[content] : content;

  return template.replace(/%s/g, () =>
    idx < values.length ? values[idx++] : '',
  );
};

export const componentTranslate = (
  lang: TLang | undefined,
  content: string,
  ...values: Array<ReactElement>
) => {
  if (typeof content !== 'string') {
    try {
      content = (content as any).toString();
    } catch (error) {
      content = 'Unknown error';
    }
  }
  const data: any =
    lang === 'en' ? en : lang === 'fr' ? fr : lang === 'es' ? es : en;
  const template = content in data ? data[content] : content;
  const elements = template.split('%s');

  let result: any = [];
  for (let i = 0; i < elements.length; i++) {
    result.push(elements[i]);
    if (i < values.length) {
      result.push(values[i]);
    }
  }
  return result;
};

type TTransKey =
  | 'backbone'
  | 'line_group'
  | 'line_type'
  | 'line_name'
  | 'line_details'
  | 'basket_count'
  | 'line'
  | 'length'
  | 'fill_percent'
  | 'line_length'
  | 'line_seed_date';
type TTransCon = 'RAFT' | 'LONGLINE' | 'MUSSEL' | 'OYSTER' | 'SEAWEED';

const reservedWords = {
  raft: {
    backbone: 'Beam length',
    line_group: 'Section group',
    line_type: 'Section type',
    line_name: 'Section name',
    line_details: 'Section details',
    basket_count: 'Number of beams',
    line: 'Section',
    length: 'Droppers',
    fill_percent: 'Section fill percentage',
    line_length: 'Number of droppers',
    line_seed_date: 'Section seeding date',
  },
  general: {
    backbone: 'Backbone length',
    line_group: 'Line group',
    line_type: 'Line type',
    line_name: 'Line name',
    line_details: 'Line details',
    basket_count: 'Number of baskets',
    line: 'Line',
    length: 'Length',
    fill_percent: 'Line fill percentage',
    line_length: 'Longline Length',
    line_seed_date: 'Line seeding date',
  },
};

export const getSizeMeasureLabel = (
  lang: TLang | undefined,
  type: 'min' | 'max' | 'avg',
  dimension: 'length' | 'width',
  prefix?: 'Top' | 'Bottom',
  managed: boolean = true,
): string => {
  if (!managed && dimension === 'length') {
    const typeWord = type === 'avg' ? 'average' : type;
    const key = prefix ? `${prefix} size ${typeWord}` : `Size ${typeWord}`;
    return translate(lang, key);
  }
  const base =
    type === 'min'
      ? `Min ${dimension}`
      : type === 'max'
        ? `Max ${dimension}`
        : `Average ${dimension}`;
  const full = prefix ? `${prefix} ${base.toLowerCase()}` : base;
  return translate(lang, full);
};

export const transUnit = (
  lang: TLang | undefined,
  keyword: TTransKey,
  condition: TTransCon | null | undefined = undefined,
) => {
  if (condition === 'RAFT') {
    return translate(lang, reservedWords.raft[keyword]);
  } else {
    return translate(lang, reservedWords.general[keyword]);
  }
};
